import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { PrintMaster_CreditNote, PrintMaster_DebitNote, PrintMaster_JobWorkerOut, PrintMaster_Payment, PrintMaster_PaySlip, PrintMaster_PrintDynamicSQL, PrintMaster_PrintItemLabel, PrintMaster_PrintSaleInvoice, PrintMaster_PrintSaleQuotation, PrintMaster_PurchaseChallan, PrintMaster_PurchaseIndent, PrintMaster_PurchaseInvoice, PrintMaster_PurchaseOrder, PrintMaster_Receipt, PrintMaster_SaleChallan, PrintMaster_SaleRelease, PrintMaster_SalesIndent, PrintMaster_SalesOrder } from "../GlobalVariables";
import { PrintMaster_ItemLabelDTOList, PrintMaster_ItemLabelRequestDTO, PrintMasterDynamicSQLRequestDTO, PrintMasterSalesInvoiceList, PrintMasterSalesInvoiceRequestDTO, PrintMasterSalesQuotationRequestDTO, PrintMaster_PurchaseChallanRequestDTO, PrintMaster_SaleChallanRequestDTO, PrintMaster_SaleReleaseRequestDTO, PrintMaster_JobWorkerOutRequestDTO, PrintMaster_CreditNoteRequestDTO, PrintMaster_DebitNoteRequestDTO, PrintMaster_PurchaseInvoiceRequestDTO, PrintMaster_PurchaseOrderRequestDTO, PrintMaster_PurchaseIndentRequestDTO, PrintMaster_PaySlipRequestDTO, PrintMaster_SalesIndentRequestDTO, PrintMaster_SalesOrderRequestDTO, PrintMaster_ReceiptRequestDTO, PrintMaster_PaymentRequestDTO } from "./print-master.interface";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PrintMasterService {
    http = inject(HttpClient);


    printReqData: any = {}


    PrintMaster_PrintSaleInvoice(data: PrintMasterSalesInvoiceRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PrintSaleInvoice, data)
    }
    PrintMaster_PrintItemLabel(data: PrintMaster_ItemLabelRequestDTO): Observable<PrintMaster_ItemLabelDTOList> {
        return this.http.post<PrintMaster_ItemLabelDTOList>(PrintMaster_PrintItemLabel, data);
    }

    PrintMaster_PrintSaleQuotation(data: PrintMasterSalesQuotationRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PrintSaleQuotation, data)
    }

    PrintMaster_PrintDynamicSQL(data: PrintMasterDynamicSQLRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PrintDynamicSQL, data)
    }

    PrintMaster_PurchaseChallan(data: PrintMaster_PurchaseChallanRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PurchaseChallan, data)
    }

    PrintMaster_SaleChallan(data: PrintMaster_SaleChallanRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_SaleChallan, data)
    }

    PrintMaster_SaleRelease(data: PrintMaster_SaleReleaseRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_SaleRelease, data)
    }
    PrintMaster_JobWorkerOut(data: PrintMaster_JobWorkerOutRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_JobWorkerOut, data);
    }
    PrintMaster_CreditNote(data: PrintMaster_CreditNoteRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_CreditNote, data);
    }
    PrintMaster_DebitNote(data: PrintMaster_DebitNoteRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_DebitNote, data);
    }
    PrintMaster_PurchaseInvoice(data: PrintMaster_PurchaseInvoiceRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PurchaseInvoice, data);
    }

    PrintMaster_PurchaseOrder(data: PrintMaster_PurchaseOrderRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PurchaseOrder, data);
    }

    PrintMaster_PurchaseIndent(data: PrintMaster_PurchaseIndentRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PurchaseIndent, data);
    }

    PrintMaster_PaySlip(data: PrintMaster_PaySlipRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_PaySlip, data);
    }

    PrintMaster_SalesIndent(data:PrintMaster_SalesIndentRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_SalesIndent, data);
    }
    PrintMaster_SalesOrder(data:PrintMaster_SalesOrderRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_SalesOrder, data);
    }

    PrintMaster_Receipt(data: PrintMaster_ReceiptRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_Receipt, data);
    }

    PrintMaster_Payment(data: PrintMaster_PaymentRequestDTO): Observable<PrintMasterSalesInvoiceList> {
        return this.http.post<PrintMasterSalesInvoiceList>(PrintMaster_Payment, data);
    }

}